// Mock data for development

export const photos = [
  {
    id: 1,
    title: "Urban Shadows",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "/almos-bechtold-3402kvtHhOo-unsplash.jpg",
    highResUrl: "/almos-bechtold-3402kvtHhOo-unsplash.jpg",
    description:
      "A cinematic portrait capturing the contrast between light and shadow in an urban environment.",
    camera: "Sony A7III",
    settings: "f/2.8, 1/125s, ISO 400",
    location: "New York City, USA",
    likes: 342,
    saves: 128,
    createdAt: "2023-09-15T10:30:00Z",
  },
  {
    id: 2,
    title: "Ethereal Light",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "/ayo-ogunseinde-6W4F62sN_yI-unsplash.jpg",
    highResUrl: "/ayo-ogunseinde-6W4F62sN_yI-unsplash.jpg",
    description:
      "Dramatic portrait using natural light filtration through fabric to create an ethereal, dreamy atmosphere.",
    camera: "Canon EOS R5",
    settings: "f/1.8, 1/60s, ISO 100",
    location: "Los Angeles, CA",
    likes: 521,
    saves: 256,
    createdAt: "2023-09-14T14:45:00Z",
  },
  {
    id: 3,
    title: "Midnight Reflections",
    photographer: "James Chen",
    photographerId: 3,
    url: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1856&q=100",
    description:
      "Low-key portrait with dramatic side lighting creating deep shadows and reflective elements.",
    camera: "Fujifilm X-T4",
    settings: "f/2.0, 1/100s, ISO 320",
    location: "Chicago, IL",
    likes: 289,
    saves: 97,
    createdAt: "2023-09-12T20:15:00Z",
  },
  {
    id: 4,
    title: "Cinematic Gaze",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1856&q=100",
    description:
      "A vibrant portrait with cinematic color grading and intense gaze creating an emotional connection.",
    camera: "Nikon Z7 II",
    settings: "f/1.4, 1/200s, ISO 64",
    location: "Miami, FL",
    likes: 578,
    saves: 203,
    createdAt: "2023-09-10T09:20:00Z",
  },
  {
    id: 5,
    title: "Shadow Play",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=100",
    description:
      "Creative use of shadow patterns on the subject's face creating a moody, film noir inspired portrait.",
    camera: "Sony A7III",
    settings: "f/3.5, 1/80s, ISO 250",
    location: "New York City, USA",
    likes: 412,
    saves: 142,
    createdAt: "2023-09-08T16:40:00Z",
  },
  {
    id: 6,
    title: "Golden Hour Portrait",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "/isco-f4ZDLFjWTr4-unsplash.jpg",
    highResUrl: "/isco-f4ZDLFjWTr4-unsplash.jpg",
    description:
      "Warm, cinematic portrait taken during the golden hour with natural rim lighting creating a magical atmosphere.",
    camera: "Canon EOS R5",
    settings: "f/2.2, 1/160s, ISO 100",
    location: "Malibu, CA",
    likes: 631,
    saves: 274,
    createdAt: "2023-09-06T19:15:00Z",
  },
  {
    id: 7,
    title: "Neon Dreams",
    photographer: "James Chen",
    photographerId: 3,
    url: "/maksim-istomin-uRdCNk7zJ_o-unsplash.jpg",
    highResUrl: "/maksim-istomin-uRdCNk7zJ_o-unsplash.jpg",
    description:
      "Urban portrait with colorful neon lighting creating a cyberpunk, cinematic atmosphere.",
    camera: "Fujifilm X-T4",
    settings: "f/1.8, 1/60s, ISO 640",
    location: "Tokyo, Japan",
    likes: 487,
    saves: 196,
    createdAt: "2023-09-04T22:35:00Z",
  },
  {
    id: 8,
    title: "Monochrome Emotion",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=644&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1288&q=100",
    description:
      "Powerful black and white portrait focusing on emotional expression and texture.",
    camera: "Nikon Z7 II",
    settings: "f/2.8, 1/125s, ISO 200",
    location: "Barcelona, Spain",
    likes: 392,
    saves: 148,
    createdAt: "2023-09-02T11:10:00Z",
  },
  {
    id: 9,
    title: "Through the Glass",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=776&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1552&q=100",
    description:
      "Creative portrait shot through glass with rain droplets creating a dreamlike, textured effect.",
    camera: "Sony A7III",
    settings: "f/3.2, 1/100s, ISO 320",
    location: "Seattle, WA",
    likes: 327,
    saves: 113,
    createdAt: "2023-09-01T14:25:00Z",
  },
  {
    id: 10,
    title: "Desert Light",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "https://images.unsplash.com/photo-1515161318750-781d6122e367?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1515161318750-781d6122e367?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3948&q=100",
    description:
      "Natural light portrait in desert landscape with dramatic clouds and golden sunset tones.",
    camera: "Canon EOS R5",
    settings: "f/4.0, 1/250s, ISO 100",
    location: "Joshua Tree, CA",
    likes: 558,
    saves: 232,
    createdAt: "2023-08-29T18:05:00Z",
  },
  {
    id: 11,
    title: "Cinematic Silhouette",
    photographer: "James Chen",
    photographerId: 3,
    url: "https://images.unsplash.com/photo-1534954553104-88cb75be7648?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1534954553104-88cb75be7648?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=100",
    description:
      "Dramatic silhouette portrait with vibrant sunset background creating a cinematic mood.",
    camera: "Fujifilm X-T4",
    settings: "f/8.0, 1/200s, ISO 160",
    location: "San Francisco, CA",
    likes: 421,
    saves: 164,
    createdAt: "2023-08-27T19:50:00Z",
  },
  {
    id: 12,
    title: "Window Light Portrait",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "https://images.unsplash.com/photo-1562572159-4efc207f5aff?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=930&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1562572159-4efc207f5aff?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1860&q=100",
    description:
      "Elegant portrait using soft window light and reflections to create depth and dimension.",
    camera: "Nikon Z7 II",
    settings: "f/2.0, 1/125s, ISO 100",
    location: "Paris, France",
    likes: 510,
    saves: 218,
    createdAt: "2023-08-25T10:40:00Z",
  },
  {
    id: 13,
    title: "Vintage Film Look",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "/alyona-grishina-BBmi4nJjKk8-unsplash.jpg",
    highResUrl: "/alyona-grishina-BBmi4nJjKk8-unsplash.jpg",
    description:
      "Portrait with cinematic color grading to mimic vintage film stock with warm tones and subtle grain.",
    camera: "Sony A7III",
    settings: "f/2.5, 1/100s, ISO 400",
    location: "Brooklyn, NY",
    likes: 376,
    saves: 143,
    createdAt: "2023-08-23T15:20:00Z",
  },
  {
    id: 14,
    title: "Dramatic Backlighting",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "https://images.unsplash.com/photo-1605405748313-a416a1b84491?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1605405748313-a416a1b84491?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=100",
    description:
      "Powerful portrait using dramatic backlighting to create a halo effect and strong contrast.",
    camera: "Canon EOS R5",
    settings: "f/2.2, 1/500s, ISO 100",
    location: "Santa Monica, CA",
    likes: 482,
    saves: 197,
    createdAt: "2023-08-21T17:35:00Z",
  },
  {
    id: 15,
    title: "Urban Motion",
    photographer: "James Chen",
    photographerId: 3,
    url: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1531384441138-2736e62e0919?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=100",
    description:
      "Dynamic urban portrait with motion blur elements to convey movement in a cinematic way.",
    camera: "Fujifilm X-T4",
    settings: "f/2.8, 1/15s, ISO 320",
    location: "Hong Kong",
    likes: 403,
    saves: 156,
    createdAt: "2023-08-19T21:10:00Z",
  },
  {
    id: 16,
    title: "Moody Atmosphere",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "https://images.unsplash.com/photo-1522767131594-6b7e96848fba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1522767131594-6b7e96848fba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1738&q=100",
    description:
      "Atmospheric portrait with fog elements creating a mysterious, cinematic mood with muted tones.",
    camera: "Nikon Z7 II",
    settings: "f/2.8, 1/200s, ISO 400",
    location: "Edinburgh, Scotland",
    likes: 439,
    saves: 183,
    createdAt: "2023-08-17T08:55:00Z",
  },
  {
    id: 17,
    title: "Candid Moment",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "/cemrecan-yurtman-zI70L5rYIiQ-unsplash.jpg",
    highResUrl: "/cemrecan-yurtman-zI70L5rYIiQ-unsplash.jpg",
    description:
      "Natural candid portrait capturing authentic emotion with cinematic composition and depth.",
    camera: "Sony A7III",
    settings: "f/2.0, 1/160s, ISO 200",
    location: "Boston, MA",
    likes: 345,
    saves: 126,
    createdAt: "2023-08-15T13:40:00Z",
  },
  {
    id: 18,
    title: "Lens Flare Portrait",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2320&q=100",
    description:
      "Creative portrait using intentional lens flare to add warm, dreamlike quality to the image.",
    camera: "Canon EOS R5",
    settings: "f/2.0, 1/250s, ISO 100",
    location: "Venice Beach, CA",
    likes: 528,
    saves: 214,
    createdAt: "2023-08-13T16:25:00Z",
  },
  {
    id: 19,
    title: "Cinematic Mood",
    photographer: "James Chen",
    photographerId: 3,
    url: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=100",
    description:
      "Classic portrait with dramatic lighting reminiscent of film noir with strong directional shadows.",
    camera: "Fujifilm X-T4",
    settings: "f/2.2, 1/125s, ISO 320",
    location: "Berlin, Germany",
    likes: 412,
    saves: 167,
    createdAt: "2023-08-11T20:15:00Z",
  },
  {
    id: 20,
    title: "Color Story",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1856&q=100",
    description:
      "Vibrant portrait with carefully curated color palette to tell a visual story through complementary tones.",
    camera: "Nikon Z7 II",
    settings: "f/1.8, 1/200s, ISO 100",
    location: "Mexico City, Mexico",
    likes: 497,
    saves: 209,
    createdAt: "2023-08-09T12:30:00Z",
  },
  {
    id: 21,
    title: "Rembrandt Lighting",
    photographer: "Alex Morgan",
    photographerId: 1,
    url: "/daniel-obscura-StdMEW50Sa8-unsplash.jpg",
    highResUrl: "/daniel-obscura-StdMEW50Sa8-unsplash.jpg",
    description:
      "Classic portrait using Rembrandt lighting technique with the characteristic triangle of light on the cheek.",
    camera: "Sony A7III",
    settings: "f/2.8, 1/125s, ISO 200",
    location: "Philadelphia, PA",
    likes: 387,
    saves: 152,
    createdAt: "2023-08-07T15:55:00Z",
  },
  {
    id: 22,
    title: "Environmental Portrait",
    photographer: "Sarah Williams",
    photographerId: 2,
    url: "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=778&q=80",
    highResUrl:
      "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1556&q=100",
    description:
      "Contextual portrait showing the subject in their natural environment with cinematic framing.",
    camera: "Canon EOS R5",
    settings: "f/4.0, 1/160s, ISO 320",
    location: "Portland, OR",
    likes: 433,
    saves: 178,
    createdAt: "2023-08-05T17:10:00Z",
  },
  {
    id: 23,
    title: "Split Lighting Drama",
    photographer: "James Chen",
    photographerId: 3,
    url: "/amirhossein-khedri-AfeYyLieLeE-unsplash.jpg",
    highResUrl: "/amirhossein-khedri-AfeYyLieLeE-unsplash.jpg",
    description:
      "High contrast portrait using split lighting to create a dramatic mood with half the face in shadow.",
    camera: "Fujifilm X-T4",
    settings: "f/2.0, 1/125s, ISO 250",
    location: "Montreal, Canada",
    likes: 376,
    saves: 145,
    createdAt: "2023-08-03T19:25:00Z",
  },
  {
    id: 24,
    title: "Soft Glow Portrait",
    photographer: "Elena Rodriguez",
    photographerId: 4,
    url: "/nyd-mkGAMtnjBtU-unsplash.jpg",
    highResUrl: "/nyd-mkGAMtnjBtU-unsplash.jpg",
    description:
      "Ethereal portrait with diffused lighting creating a soft glow effect and dreamy atmosphere.",
    camera: "Nikon Z7 II",
    settings: "f/2.2, 1/80s, ISO 100",
    location: "Stockholm, Sweden",
    likes: 461,
    saves: 199,
    createdAt: "2023-08-01T10:40:00Z",
  },
];

export const featuredPhotographer = {
  id: 2,
  name: "Sarah Williams",
  username: "sarahwilliams",
  bio: "Award-winning portrait photographer specializing in cinematic lighting and emotional storytelling through images. My work explores the human condition through dramatic contrast and authentic moments.",
  avatar:
    "https://images.unsplash.com/photo-1561406636-b80293969660?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
  coverPhoto:
    "https://images.unsplash.com/photo-1520207588543-0e61b1f2ca5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80",
  location: "Los Angeles, CA",
  website: "https://www.example.com/sarahwilliams",
  camera: "Canon EOS R5, Hasselblad 907X",
  specialties: [
    "Low-Key Portraits",
    "Cinematic Color Grading",
    "Environmental Portraits",
  ],
  featuredImage:
    "https://images.unsplash.com/photo-1515161318750-781d6122e367?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80",
  previewImages: [
    "https://images.unsplash.com/photo-1552642986-ccb41e7059e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=644&q=80",
    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=776&q=80",
  ],
  stats: {
    photos: 148,
    followers: 12500,
    following: 235,
  },
};

export const photographers = [
  {
    id: 1,
    name: "Alex Morgan",
    username: "alexmorgan",
    bio: "Fine art portrait photographer with a focus on emotive storytelling. My work aims to capture the essence of human expression through cinematic techniques.",
    avatar:
      "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
    coverPhoto:
      "https://images.unsplash.com/photo-1535979014625-490762ceb2cd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80",
    location: "New York, NY",
    website: "https://www.example.com/alexmorgan",
    camera: "Sony A7III, Leica Q2",
    specialties: ["Dramatic Lighting", "Urban Portraiture", "Black & White"],
    stats: {
      photos: 187,
      followers: 9300,
      following: 412,
    },
  },
  {
    id: 2,
    name: "Sarah Williams",
    username: "sarahwilliams",
    bio: "Award-winning portrait photographer specializing in cinematic lighting and emotional storytelling through images. My work explores the human condition through dramatic contrast and authentic moments.",
    avatar:
      "https://images.unsplash.com/photo-1561406636-b80293969660?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    coverPhoto:
      "https://images.unsplash.com/photo-1520207588543-0e61b1f2ca5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80",
    location: "Los Angeles, CA",
    website: "https://www.example.com/sarahwilliams",
    camera: "Canon EOS R5, Hasselblad 907X",
    specialties: [
      "Low-Key Portraits",
      "Cinematic Color Grading",
      "Environmental Portraits",
    ],
    stats: {
      photos: 148,
      followers: 12500,
      following: 235,
    },
  },
  {
    id: 3,
    name: "James Chen",
    username: "jameschen",
    bio: "Visual storyteller merging traditional portrait techniques with modern cinematic influences. I strive to create images that evoke emotion and challenge perception.",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    coverPhoto:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80",
    location: "Chicago, IL",
    website: "https://www.example.com/jameschen",
    camera: "Fujifilm X-T4, Ricoh GR III",
    specialties: ["Street Portraits", "Neon Lighting", "Urban Documentaries"],
    stats: {
      photos: 121,
      followers: 7800,
      following: 312,
    },
  },
];
